import { useMemo, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import DateSelect from "../XoSoSidebar/DateSelect";
import useVietlottResults from "../VietlottCompound/useVietlottResults";
import { GAME_META, resolveVietlottGames, TZ } from "../VietlottCompound/constants";
import CompactVietlottResult from "./CompactVietlottResult";
import "../XoSoSidebar/XoSoSidebar.css";
import "./VietlottSidebar.css";

dayjs.extend(utc);
dayjs.extend(timezone);

function VietlottSidebar({ category, lotteryType, config }) {
  const games = useMemo(() => {
    const list = resolveVietlottGames(category ?? lotteryType ?? config?.lotteryType ?? "mega");
    return [list[0]];
  }, [category, lotteryType, config?.lotteryType]);
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [date, setDate] = useState(null);
  const { results, loading, resolvedDate } = useVietlottResults(date, games);
  const selectedDate = date || resolvedDate || today;
  const meta = GAME_META[games[0]];

  return (
    <div className="xoso-sidebar vietlott-sidebar">
      <div className="xoso-sidebar__head">
        <div className="xoso-sidebar__title">
          KQXS <span>{meta?.title || "Vietlott"}</span>
        </div>
        <DateSelect value={selectedDate} onChange={setDate} maxDate={today} />
      </div>
      <CompactVietlottResult result={results[0]} date={selectedDate} loading={loading} />
    </div>
  );
}

VietlottSidebar.DateSelect = DateSelect;
VietlottSidebar.Result = CompactVietlottResult;

export { DateSelect, CompactVietlottResult };
export default VietlottSidebar;
